// dopple-init.js - V2 Dopple SDK early initialization
// =============================================================================
// Loaded as a type="module" from <head> on V2 so the browser can start fetching
// and initializing the Dopple SDK as early as possible. UI glue code and
// window.updateSelection / window.captureCartSnapshot / etc. live in
// the-anthros-chair-2026.js, which executes after this module.
// =============================================================================

import { DoppleXR } from 'https://builds.dopple.io/packages/dopple-sdk@2026.21.0/dopple-sdk.js'

const currentPath = window.location.pathname
const isMobile = window.innerWidth <= 900

// Configuration menu mapping for Dopple
const configMenu = [
    {
        title: 'Chair Color Options',
        property: 'chassisColor',
        options: [
            { title: 'ONYX', value: 'onyx' },
            { title: 'QUARTZ +$99', value: 'quartz' },
			{ title: 'QUARTZ +$0 MEMORIAL DAY', value: 'quartz' },
        ]
    },
    {
        title: 'Fabric Options',
        property: 'fabric',
        options: [
            { title: 'IVORY', value: 'ivoryGAFabric' },
            { title: 'ONYX', value: 'heatherBlackGAFabric' },
            { title: 'STEEL', value: 'steelGAFabric' },
            { title: 'DUNE', value: 'duneGAFabric' },
            { title: 'PINK', value: 'pinkGAFabric' },
            { title: 'LAVENDER', value: 'lavenderGAFabric' },
            { title: 'IVORY PORT +$199', value: 'ivoryPort' },
            { title: 'ONYX PORT +$199', value: 'onyxPort' },
            { title: 'STEEL PORT +$199', value: 'steelPort' },
            { title: 'DUNE PORT +$199', value: 'dunePort' },
            { title: 'IVORY PORT +$0 MEMORIAL DAY', value: 'ivoryPort' },
            { title: 'ONYX PORT +$0 MEMORIAL DAY', value: 'onyxPort' },
            { title: 'STEEL PORT +$0 MEMORIAL DAY', value: 'steelPort' },
            { title: 'DUNE PORT +$0 MEMORIAL DAY', value: 'dunePort' },
        ]
    },
    {
        title: 'Back Panel Options',
        property: 'backPanel',
        options: [
            { title: 'ONYX', value: 'standardBlackV2' },
            { title: 'IVORY', value: 'standardIvory' },
            { title: 'NATURAL OAK +$79', value: 'naturalOakV2' },
            { title: 'AMBER ELM +$79', value: 'sierraOakV2' },
            { title: 'IVORY OAK +$79', value: 'ivoryOak' },
            { title: 'GREY OAK +$79', value: 'greyOak' },
            { title: 'WARM EBONY +$79', value: 'warmEbony' },
            { title: 'WALNUT +$149', value: 'walnutV2' },
            { title: 'CARBON FIBER +$299', value: 'carbonFushion' },
            { title: 'CIRCUIT BLACK +$79', value: 'circuitOnyx' },
            { title: 'CIRCUIT WHITE +$79', value: 'circuitIvory' },
            { title: 'SKELETON WHITE +$79', value: 'skeleton1' },
            { title: 'SKELETON BLACK +$79', value: 'skeleton2' },
            { title: 'MIAMI HERETICS +$79', value: 'miamiHeretics' },
            { title: 'EVIL GENIUSES +$79', value: 'evilGeniuses' },
    		{ title: 'US FLAG +$79', value: 'colorFlagUSA' },
            { title: 'BITCOIN MONEY +$79', value: 'bitcoinMoney' },
            { title: 'BITCOIN LETTERPRESS +$79', value: 'bitcoinLetterpress' },
            { title: 'NATURAL OAK +$0 MEMORIAL DAY', value: 'naturalOakV2' },
            { title: 'SIERRA OAK +$0 MEMORIAL DAY', value: 'sierraOakV2' },
            { title: 'IVORY OAK +$0 MEMORIAL DAY', value: 'ivoryOak' },
            { title: 'GREY OAK +$0 MEMORIAL DAY', value: 'greyOak' },
            { title: 'WARM EBONY +$0 MEMORIAL DAY', value: 'warmEbony' },
            { title: 'WALNUT +$0 MEMORIAL DAY', value: 'walnut' },
            { title: 'CARBON FIBER +$0 MEMORIAL DAY', value: 'carbonFusion' },
            { title: 'CIRCUIT BLACK +$0 MEMORIAL DAY', value: 'circuitOnyx' },
            { title: 'CIRCUIT WHITE +$0 MEMORIAL DAY', value: 'circuitIvory' },
            { title: 'SKELETON WHITE +$0 MEMORIAL DAY', value: 'skeleton1' },
            { title: 'SKELETON BLACK +$0 MEMORIAL DAY', value: 'skeleton2' },
            { title: 'US FLAG +$0 MEMORIAL DAY', value: 'colorFlagUSA' },
            { title: 'MIAMI HERETICS +$0 MEMORIAL DAY', value: 'miamiHeretics' },
            { title: 'BITCOIN MONEY +$0 MEMORIAL DAY', value: 'bitcoinMoney' },
            { title: 'BITCOIN LETTERPRESS +$0 MEMORIAL DAY', value: 'bitcoinLetterpress' },
        ]
    },
    {
        title: 'Control Caps',
        property: 'controlArmCapColor',
        options: [
            { title: 'GLOSS STONE', value: 'glossStone' },
            { title: 'SHINY BLACK', value: 'shinyBlack' },
            { title: 'SHINY CHROME +$39', value: 'shinyChrome' },
            { title: 'SHINY GOLD +$49', value: 'shinyGold' },
            { title: 'SHINY CHROME +$0 MEMORIAL DAY', value: 'shinyChrome' },
            { title: 'SHINY GOLD +$0 MEMORIAL DAY', value: 'shinyGold' },
        ]
    },
    {
        title: 'Base Style Options',
        property: 'base',
        options: [
            { title: 'FIXED 4 SPOKE', value: 'fourSpoke' },
            { title: 'SWIVEL 5 SPOKE', value: 'fiveSpoke' },
        ]
    },
    {
        title: 'Arm Options',
        property: '4DArms',
        options: [
            { title: '4D ARMS +$99', value: 'add' },
            { title: 'NO ARMS', value: 'none' },
        ]
    }
];

window.configMenu = configMenu;

// Default selection
const selection = {
    '4DArms': 'add',
    'autoRotation': isMobile ? 'off' : 'on',
    'backPanel': 'standardBlack',
    'base': 'fiveSpoke',
    'cameraView': 'front',
    'chassisColor': 'onyx',
    'controlArmCapColor': 'shinyBlack',
    'fabric': 'heatherBlackGAFabric',
    'hotspots': 'off',
}

// URL-based preset configurations
if (currentPath === '/products/anthros-chair-configuration-one') {
    Object.assign(selection, {
        'fabric': 'heatherBlackGAFabric',
        'backPanel': 'walnut'
    })
} else if (currentPath === '/products/anthros-chair-configuration-two') {
    Object.assign(selection, {
        'fabric': 'ivoryGAFabric',
        'backPanel': 'naturalOakV2',
        'chassisColor': 'quartz',
        'controlArmCapColor': 'glossStone'
    })
}

(async () => {
  // Initialize Dopple
    const dopple = new DoppleXR({
        container: document.querySelector("#dopple-container"),
        selection,
        productVersion: "27",
        owner: "anthros",
        workspace: "anthros",
        projectName: "anthros-the-chair",
    })
  window.dopple = dopple

  // Progress tracking
  const progressElement = document.querySelector(".progress");
  if (progressElement) {
      dopple.loadingManager.onProgress = (_url, current, total) => {
          progressElement.textContent = `${Math.round(current / total * 100)}%`;
      };
  }

  // Load and initialize
  const loadStatus = await dopple.load()

  // Hide loading screen after Dopple loads
  const stickyImg = document.querySelector('.sticky_img');
  if (stickyImg) {
      stickyImg.classList.add('dopple_loaded');
  }

  const mwApoPrice = document.querySelector('.mw-apo-price-custom');
  if (mwApoPrice) {
      mwApoPrice.classList.add('dopple_loaded');
  }

  const loadingBg = document.querySelector('.loading_bg');
  if (loadingBg) {
      loadingBg.classList.add('dopple_loaded');
  }

  // Stop auto-rotation on first pointer interaction.
  // Previously used transitionstart on dopple.controls, which fires on every
  // auto-rotation frame → 60 queued updateSelection promises/sec → stutter.
  // pointerdown fires once, cleanly, before the drag begins.
  document.querySelector('#dopple-container')
      ?.addEventListener('pointerdown', () => {
          dopple.updateSelection({ 'autoRotation': 'off' });
      }, { passive: true, once: true });

  dopple.run();

  setTimeout(() => {
        console.log('💰 Showing price after Dopple load');
        document.querySelectorAll('.loading_price').forEach(el => el.setAttribute('style', 'opacity:0'));
        document.querySelectorAll('.price-item--regular').forEach(el => el.setAttribute('style', 'opacity:1'));
    }, 1500);
})();